import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import AcknowledgementForm from './dynamic-form/AcknowledgementForm';
import AcknowledgementElement from './dynamic-report/AcknowledgementElement';
import SkipedAckElement from "./dynamic-report/SkipedAckElement";

class ReportAcknowledgement extends Component {
  // ----------------------
  // Computed
  // ----------------------

  get canAcknowledge() {
    return this.props.report.getCanAcknowledge(this.props.userContext.scope) || this.props.canSkip;
  }

  get showAcknowledgement() {
    return this.props.report.acknowledgedAt;
  }

  get showSkippedAcknowledgement() {
    return this.props.report.ack_skipped_at;
  }

  //ack_skipper

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Fragment>
        {this.canAcknowledge &&
        <AcknowledgementForm
          responsesAck={this.props.responsesAck}
          requriedAckResponsesFilled={this.props.requriedAckResponsesFilled}
          reportGuid={this.props.report.guid}
          requireAckComment={this.props.report.settings && this.props.report.settings.requireAckComment}
          canSkip={this.props.canSkip}
        />
        }
        {this.showAcknowledgement &&
        <AcknowledgementElement
          acknowledgedAt={this.props.report.acknowledgedAt}
          ackComment={this.props.report.ack_comment}
          acknowledgedBy={this.props.report.getFullNameFor('acknowledger')}
        />
        }
        {this.showSkippedAcknowledgement &&
        <SkipedAckElement
          acknowledgedAt={this.props.report.ack_skipped_at}
          ackComment="Skipped acknowledgement"
          acknowledgedBy={this.props.report.getFullNameFor('ack_skipper')}
        />
        }
      </Fragment>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    userContext: state.common.userContext,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // TODO
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportAcknowledgement);
